import { DialogTitle } from "@material-ui/core";

export default DialogTitle;
